import { Epic, ofType } from "redux-observable";
import { catchError, map, merge, mergeMap, of, takeUntil } from "rxjs";
import { IAction } from "../../../interface/action.interface";
import { IErrorDto } from "../../../interface/dto/error.dto";
import { IRootState } from "../../../redux/root.reducer";
import { searchList } from "../../../service/list-search.api";
import { selectAuthTokens } from "../../auth/selectors/auth.selector";
import {
    IListSearchGetAction,
    ListSearchActionType,
    listSearchErrorAction,
    listSearchSuccessAction,
} from "./list-search.actions";

const searchLimit = 20;

export const listSearchEpic: Epic<IAction, IAction, IRootState> = (action$) =>
    merge(
        action$.pipe(
            ofType<IListSearchGetAction, ListSearchActionType.LIST_SEARCH_GET>(
                ListSearchActionType.LIST_SEARCH_GET,
            ),
            mergeMap((action) =>
                (action.payload.filter.length
                    ? searchList(
                          action.payload.filter,
                          selectAuthTokens(),
                          searchLimit,
                      )
                    : of([])
                ).pipe(
                    takeUntil(
                        action$.pipe(
                            ofType<
                                IListSearchGetAction,
                                ListSearchActionType.LIST_SEARCH_GET
                            >(ListSearchActionType.LIST_SEARCH_GET),
                        ),
                    ),
                    map((result) => listSearchSuccessAction(result)),
                    catchError((error: IErrorDto) =>
                        of(listSearchErrorAction(error.message)),
                    ),
                ),
            ),
        ),
    );
